import { put, takeLatest, all, call } from 'redux-saga/effects'
import { getElectricMeterDetailSuccessAction } from 'src/redux/actions/electricMeter'
import { ACTION_GET_ELECTRIC_METER_DETAIL } from 'src/redux/actions/electricMeter/ElectricMeterActions'
import instance from 'src/services/api'
import { Endpoint } from '../Endpoint'

function* getElectricMeterDetail(action) {
  try {
    const configRequest = () => {
      return instance.get(`${Endpoint.ELECTRIC_METER_DETAIL}?${action.payload}`)
    }
    const response = yield call(configRequest)
    yield put(getElectricMeterDetailSuccessAction(response?.data))
  } catch (error) {
    const status = error?.response?.data?.status
    const msg = error?.response?.data?.error?.message
    const code = error?.response?.data?.error?.code
    yield put(
      getElectricMeterDetailSuccessAction({
        status: status,
        code: code,
        message: msg,
      }),
    )
  }
}

export default function* electricMeterSaga() {
  yield all([takeLatest(ACTION_GET_ELECTRIC_METER_DETAIL, getElectricMeterDetail)])
}
